<script setup>
import { RANGES } from '../lib/ranges.js'

defineProps({
  range: { type: String, required: true },
  rangosEnCache: { type: Array, default: () => [] },
  loading: Boolean,
  progress: String,
  fromCache: Boolean,
  lastRun: String,
  subcuenta: { type: String, default: '' },
})
const emit = defineEmits(['range', 'cancelar', 'refrescar'])

const hora = (iso) => (iso ? new Date(iso).toLocaleTimeString('es-EC', { hour: '2-digit', minute: '2-digit' }) : '')
</script>

<template>
  <div class="card barra no-print">
    <div class="row">
      <div class="grow">
        <h1>Leads no gestionados</h1>
        <p class="muted sub">
          <template v-if="subcuenta">{{ subcuenta }}</template>
          <template v-else>Datos de demostracion</template>
          <template v-if="lastRun">
            · datos de las {{ hora(lastRun) }}
            <span v-if="fromCache" class="cache">desde cache</span>
          </template>
        </p>
      </div>

      <div class="rangos" role="group" aria-label="Ventana temporal">
        <button
          v-for="r in RANGES" :key="r.id"
          :class="{ activo: range === r.id, cacheado: rangosEnCache.includes(r.id) }"
          :disabled="loading"
          :title="rangosEnCache.includes(r.id) ? 'Ya cargado: cambio instantaneo' : 'Requiere descargar datos'"
          @click="emit('range', r.id)"
        >
          {{ r.short }}
          <span v-if="rangosEnCache.includes(r.id)" class="punto" aria-hidden="true" />
        </button>
      </div>

      <button v-if="loading" @click="emit('cancelar')">Cancelar</button>
      <button v-else class="primary" @click="emit('refrescar')">Actualizar</button>
    </div>

    <div v-if="loading" class="cargando">
      <span class="mono">{{ progress || 'Cargando...' }}</span>
      <span class="pista" />
    </div>
  </div>
</template>

<style scoped>
.barra { padding: 14px 16px; margin-bottom: 16px; }
.sub { margin: 2px 0 0; font-size: 12.5px; }
.cache {
  display: inline-block; margin-left: 4px; padding: 0 6px; border-radius: 999px;
  background: var(--surface-2); font-size: 11px; font-weight: 600;
}
.rangos { display: flex; gap: 0; }
.rangos button {
  border-radius: 0; margin-left: -1px; position: relative;
  display: flex; align-items: center; gap: 5px;
}
.rangos button:first-child { border-radius: 8px 0 0 8px; margin-left: 0; }
.rangos button:last-child { border-radius: 0 8px 8px 0; }
.rangos button.activo {
  background: var(--accent); border-color: var(--accent); color: #fff; z-index: 1;
}
.punto { width: 5px; height: 5px; border-radius: 50%; background: var(--ok); }
.rangos button.activo .punto { background: rgba(255, 255, 255, .8); }

.cargando { display: grid; gap: 6px; margin-top: 10px; font-size: 12px; color: var(--muted); }
.pista { height: 3px; border-radius: 999px; background: var(--surface-2); overflow: hidden; position: relative; }
.pista::after {
  content: ''; position: absolute; inset: 0; width: 35%;
  background: var(--accent); border-radius: 999px;
  animation: desliza 1.1s ease-in-out infinite;
}
@keyframes desliza {
  from { transform: translateX(-100%); }
  to { transform: translateX(320%); }
}
</style>
